var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showZcmDomainWarning)?_c('zm-alert',{staticClass:"opc-cart__zcm-domain-warning",attrs:{"title":_vm.$t('billing.zcm.domain_restriction_warning'),"type":"warning","show-icon":"","closable":true},on:{"close":_vm.handleClose}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }